export const PRICE = "PRICE";
export const priceAction = (data) => {
    return {
        type: PRICE,
        payload:data
    }
}